/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_Mode_PartialInputs */

const vi_refund_mode_partial = /** @type {(inputs: Refund_Mode_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn một phần`)
};

/**

* @param {Refund_Mode_PartialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_mode_partial = /** @type {((inputs?: Refund_Mode_PartialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_Mode_PartialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_mode_partial(inputs)
});